import { render } from "./PointShopItem.vue?vue&type=template&id=fec2a5b8&scoped=true"
import script from "./PointShopItem.vue?vue&type=script&lang=js"
export * from "./PointShopItem.vue?vue&type=script&lang=js"

import "./PointShopItem.vue?vue&type=style&index=0&id=fec2a5b8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fec2a5b8"]])

export default __exports__